import { render, staticRenderFns } from "./CommonRules.vue?vue&type=template&id=0d122b6c&scoped=true&"
import script from "./CommonRules.vue?vue&type=script&lang=js&"
export * from "./CommonRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d122b6c",
  null
  
)

export default component.exports